import { APICallV3Post } from 'reactApp/api/APICall';

type SubscriptionFreemiumResponse = { result?: 'success'; sub_id?: string; error?: string };

export class SubscriptionFreemiumAPICall extends APICallV3Post<SubscriptionFreemiumResponse> {
    _method = 'billing/subscription/freemium';
}
